import {
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
} from 'date-fns';
import { CalendarViewMode } from './types';

export const getDateRangeForMode = (
  currentDay: Date,
  mode: CalendarViewMode,
) => {
  let rangeStart: Date;
  let rangeEnd: Date;

  switch (mode) {
    case 'day':
      rangeStart = startOfDay(currentDay);
      rangeEnd = endOfDay(currentDay);
      break;
    case 'week':
      rangeStart = startOfWeek(currentDay, { weekStartsOn: 1 });
      rangeEnd = endOfWeek(currentDay, { weekStartsOn: 1 });
      break;
    case 'month':
      rangeStart = startOfMonth(currentDay);
      rangeEnd = endOfMonth(currentDay);
      break;
    case 'year':
      rangeStart = startOfYear(currentDay);
      rangeEnd = endOfYear(currentDay);
      break;
    default:
      rangeStart = startOfWeek(currentDay, { weekStartsOn: 1 });
      rangeEnd = endOfWeek(currentDay, { weekStartsOn: 1 });
  }

  return {
    startDate: rangeStart.toISOString(),
    endDate: rangeEnd.toISOString(),
  };
};
